import { apiClient } from './client';

export interface FormInfo {
  formType: string;
  name: string;
  supportsFilling: boolean;
  totalFields: number;
  reason?: string;
}

export interface FormPreviewResponse {
  success: boolean;
  data?: {
    base64: string;
    mimeType: string;
    fileName: string;
    supportsFilling: boolean;
    filledFieldCount: number;
    totalFieldCount: number;
  };
  error?: string;
}

export const formsApi = {
  getFormData: async (caseId: string, formType: string) => {
    return apiClient.get(`/forms/${caseId}/${formType}`);
  },

  saveFormData: async (caseId: string, formType: string, data: Record<string, unknown>) => {
    return apiClient.post(`/forms/${caseId}/${formType}`, data);
  },

  refillFormData: async (caseId: string, formType: string) => {
    return apiClient.post(`/forms/${caseId}/${formType}/refill`, {});
  },

  downloadPdf: async (caseId: string, formType: string) => {
    return apiClient.postBlob(`/forms/${caseId}/${formType}/download`, {});
  },

  /**
   * Get PDF preview as base64 for inline viewing
   */
  getFormPreview: async (caseId: string, formType: string): Promise<FormPreviewResponse> => {
    return apiClient.get(`/forms/${caseId}/${formType}/preview`);
  },

  /**
   * Save the filled form as a document attached to the case
   */
  saveFormToCase: async (caseId: string, formType: string) => {
    return apiClient.post(`/forms/${caseId}/${formType}/save-to-case`, {});
  },

  /**
   * Get form info including filling capability
   */
  getFormInfo: async (formType: string): Promise<FormInfo> => {
    return apiClient.get(`/forms/${formType}/info`);
  },

  /**
   * Download XFDF data file for XFA forms
   * XFA forms cannot be filled programmatically, so we provide XFDF for import into Adobe Acrobat
   */
  downloadXfdf: async (caseId: string, formType: string) => {
    return apiClient.getBlob(`/forms/${caseId}/${formType}/xfdf`);
  },

  /**
   * Get fill instructions for XFA forms (human-readable text)
   */
  getFillInstructions: async (caseId: string, formType: string) => {
    return apiClient.get(`/forms/${caseId}/${formType}/fill-instructions`);
  },
};
